module.exports = __webpack_public_path__ + "static/media/calendar_1_day.8b682f23.svg";